import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import useIsMobile from "lib/hooks/useIsMobile";
import { ViewModeToggleButtons } from "components/ToolBar/parts/ViewModeToggleButtons";
import { MobileFilterButton } from "pages/redesign/menuFilterBar/parts/FilterButton";
import { push, setParam, removeParam, resetToFirstPage } from "api/search/filterUrlMaker";
import { OrderByDropdownRedesign } from "./OrderByDropdown";
import { getParam } from "../../../../lib/routing";
import { ButtonTabGroup } from "./ButtonTabGroup";

const READ_COUNT_4h = "ReadCount_4h";
const READ_COUNT_24H = "ReadCount_24h";
const READ_COUNT_7D = "ReadCount_7d";
const READ_COUNT_30D = "ReadCount_30d";

const sortTime = [
  { value: READ_COUNT_4h, label: "Last 4 hours" },
  { value: READ_COUNT_24H, label: "Last 24 hours" },
  { value: READ_COUNT_7D, label: "Last 7 days" },
  { value: READ_COUNT_30D, label: "Last 30 days" },
  { value: "ReadCount_Desc", label: "All" },
];

function getSortParam() {
  const sort = getParam("sort");
  if (!sort || sortTime.some((opt) => opt.value === sort)) {
    return sort || "Date_Desc";
  }
  return sort;
}

export function Toolbar({ viewMode, setViewMode, searchResults, showOrderByPopularity = true, themeInFocusData }) {
  const location = useLocation();
  const isMobile = useIsMobile();

  const sort = getSortParam();
  const isTabActive = sortTime.some((option) => option.value === sort);
  const activeTab = isTabActive ? sort : READ_COUNT_24H;
  const [orderBy, setOrderBy] = useState(isTabActive ? READ_COUNT_24H : sort);

  useEffect(() => {
    if (isMobile && (sort === "ReadCount_Desc" || sort === READ_COUNT_24H)) {
      setOrderBy(READ_COUNT_24H);
      push(resetToFirstPage(setParam("sort", "ReadCount_Desc")));
    } else if (isTabActive) {
      setOrderBy(READ_COUNT_24H);
    } else {
      setOrderBy(sort);
    }
    // eslint-disable-next-line
  }, [location.search, isMobile]);

  const handleChange = (value) => {
    if (isMobile && value === READ_COUNT_24H) {
      setOrderBy(READ_COUNT_24H);
      push(resetToFirstPage(setParam("sort", "ReadCount_Desc")));
    } else if (value === READ_COUNT_24H) {
      setOrderBy(READ_COUNT_24H);
      push(resetToFirstPage(setParam("sort", READ_COUNT_24H)));
    } else if (sortTime.some((option) => option.value === value)) {
      setOrderBy(READ_COUNT_24H);
      push(resetToFirstPage(setParam("sort", value)));
    } else {
      setOrderBy(value);
      if (value) {
        push(resetToFirstPage(setParam("sort", value)));
      } else {
        push(resetToFirstPage(removeParam("sort")));
      }
    }
  };

  return (
    <section className="d-flex flex-row align-items-center mb-2 overflow-x-auto">
      <OrderByDropdownRedesign orderBy={orderBy} setOrderBy={handleChange} showOrderByPopularity={showOrderByPopularity} />
      {!isMobile && orderBy === READ_COUNT_24H && isTabActive && (
        <ButtonTabGroup activeTab={activeTab} tabOptions={sortTime} handleChange={handleChange} />
      )}
      <div className="ml-auto flex-shrink-0">
        {isMobile && <MobileFilterButton aggregations={searchResults?.[3]} themeInFocusData={themeInFocusData} />}
        <ViewModeToggleButtons viewMode={viewMode} setViewMode={setViewMode} className="m-0" />
      </div>
    </section>
  );
}
